import { Controller } from "@hotwired/stimulus"
import React, { Suspense } from "react"
import { render } from "react-dom"
import { BrowserRouter as Router } from "react-router-dom"
import { Loading, ModalContainer, SubjectImports } from "web/components"
import { TLOContextProvider } from "web/contexts"
import { AppProviders, LibraryProviders } from "web/Providers"

export default class SubjectImportsController extends Controller {
  static values = {
    basePath: String,
    type: { type: String, default: "multi_topic_record" },
    subjectType: String,
    subjectId: Number,
    userPermissions: Object,
  }

  initialize() {
    global.React = React
  }

  connect() {
    const contextProviderData = {
      id: this.subjectIdValue,
      resource_type: this.subjectTypeValue,
      user_permissions: this.userPermissionsValue,
    }

    render(
      <Suspense fallback={<Loading />}>
        <Router>
          <LibraryProviders>
            <AppProviders>
              <TLOContextProvider
                subjectType={this.subjectTypeValue}
                data={contextProviderData}
              >
                <SubjectImports
                  basePath={this.basePathValue}
                  type={this.typeValue}
                />
              </TLOContextProvider>
              <ModalContainer />
            </AppProviders>
          </LibraryProviders>
        </Router>
      </Suspense>,
      this.element
    )
  }
}
